// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1WnF6","header":"ClearentDisclaimer_header__A04CK","inner":"ClearentDisclaimer_inner__3SNKM"};